import { useState } from 'react'

import { IPFS_URL } from '../../app/constants'
import useWax from '../../hooks/useWax'

const selectorStyle =
  'w-[35px] h-[35px] flex justify-center items-center border-[0.3px] border-solid rounded-md cursor-pointer'

const ShopItem = ({ price, available, title, img, video, id }) => {
  const [qty, setQty] = useState(0)
  const { buyAction } = useWax()

  return (
    <div className="text-white flex flex-col gap-4">
      <div className="w-[250px]">
        {img ? (
          <img src={`${IPFS_URL}${img}`} alt={title} />
        ) : (
          <video src={`${IPFS_URL}${video}`} alt={title} />
        )}
      </div>
      <div className="flex flex-col text-[#AD945F]">
        <span>{title}</span>
        <span>
          Available:{' '}
          <span className="text-white">{available.toLocaleString()}</span>
        </span>
        <span>
          GLK: <span className="text-white">{price.toLocaleString()}</span>
        </span>
      </div>
      <div className="w-full flex gap-2">
        <div
          className={selectorStyle + ' border-[#00FFF0] '}
          onClick={() =>
            setQty((qty) =>
              parseInt(qty) > 0
                ? `${parseInt(qty) - 1}`
                : `${parseInt(
                    isNaN(Number(available)) ? qty : Number(available),
                  )}`,
            )
          }
        >
          -
        </div>
        <div
          className={
            selectorStyle + ' !w-auto !flex-1 border-[#AD945F] !cursor-default'
          }
        >
          {qty}
        </div>
        <div
          className={selectorStyle + ' border-[#00FFF0] '}
          onClick={() =>
            setQty((qty) =>
              parseInt(qty) < Number(available)
                ? `${parseInt(qty) + 1}`
                : `${parseInt('0')}`,
            )
          }
        >
          +
        </div>
      </div>
      <div>
        <div
          onClick={() => +qty > 0 && buyAction(id, price, +qty)}
          disabled={+qty === 0}
          className={selectorStyle + ' !w-full border-[#00FFF0] ' + (+qty === 0 ? 'opacity-50 cursor-not-allowed' : '')}
        >
          Buy
        </div>
      </div>
    </div>
  )
}

export default ShopItem
